import type { Filter } from '../types'

export const STOCK_FILTERS: Filter[] = [
    { name: 'Renewable energy', emoji: '🔋', tag: '🔋 Renewable Energy', isPositive: true },
    { name: 'Energy transition materials', emoji: '⛏️⚡️', tag: '⛏️⚡️ Energy transition materials', isPositive: true },
    { name: 'Water efficiency', emoji: '💧', tag: '💧 Water Efficiency', isPositive: true },
    { name: 'Nutritious foods', emoji: '🥕', tag: '🥬 Nutritious foods', isPositive: true },
    { name: 'Recycling and waste management', emoji: '♻️', tag: '♻️ Recycling and waste management', isPositive: true },
    { name: 'Healthcare', emoji: '🏥', tag: '🏥 Healthcare ', isPositive: true },
    { name: 'Electric vehicles', emoji: '🚗⚡️', tag: '🚗⚡ Electric vehicles', isPositive: true },
    { name: 'Education', emoji: '🎓', tag: '🎓 Education', isPositive: true },
    { name: 'Sustainable buildings', emoji: '🏡', tag: '🏙️ Sustainable buildings', isPositive: true },
    { name: 'Factory farming', emoji: '🐓', tag: '🐓 Factory farming ', isPositive: false },
    {
        name: 'Junk foods and highly processed foods',
        emoji: '🍔',
        tag: '🍔 Junk foods and highly processed foods ',
        isPositive: false,
    },
    { name: 'Alcohol', emoji: '🍺', tag: '🍺 Alcohol ', isPositive: false },
    { name: 'Live animal export', emoji: '🚢', tag: '🚢 Live animal export', isPositive: false },
    { name: 'Tobacco', emoji: '🚬', tag: '🚬 Tobacco ', isPositive: false },
    { name: 'Gambling', emoji: '🎲', tag: '🎲 Gambling', isPositive: false },
    { name: 'Uranium and nuclear', emoji: '☢️', tag: '☢️ Uranium and nuclear', isPositive: false },
    { name: 'Fossil fuel electricity', emoji: '🏭', tag: '🏭 Fossil fuel electricity  ', isPositive: false },
    { name: 'Palm oil', emoji: '🌴', tag: '🌴 Palm oil', isPositive: false },
    { name: 'Weapons and military services', emoji: '💣', tag: '💣 Weapons and military services', isPositive: false },
    { name: 'Single use plastics', emoji: '🥤', tag: '🥤Single use plastics', isPositive: false },
    { name: 'Fossil fuels', emoji: '🛢️', tag: '🛢️ Fossil Fuels', isPositive: false },
]

export const STOCK_POSITIVE_FILTERS = STOCK_FILTERS.filter((f) => f.isPositive)
export const STOCK_NEGATIVE_FILTERS = STOCK_FILTERS.filter((f) => !f.isPositive)

export default STOCK_FILTERS
